/**
 * True when a keystroke belongs to a text-entry control and must not be stolen by a page or
 * overlay shortcut. Covers the event target and the focused element (they diverge when a keydown
 * is retargeted), plus TipTap's contenteditable body via `isContentEditable`, which is also true
 * for nested nodes inside the editor.
 */
export function isTypingTarget(event: KeyboardEvent): boolean {
  const TEXT_ENTRY = 'input, textarea, select, [contenteditable]:not([contenteditable="false"])';
  const nodes = [event.target, document.activeElement];
  return nodes.some((node) => {
    if (!(node instanceof HTMLElement)) return false;
    return node.isContentEditable || !!node.closest(TEXT_ENTRY);
  });
}
